import { AxnCompany } from "@idw-types/data/reference-data/axn"
import { FormattedRpServiceTemplate, RpServiceTemplate } from "@idw-types/data/reference-data/generic";
import { toObject } from "@utils/object-util";

export const formatServiceTemplates = (serviceTemplates: Array<RpServiceTemplate>, axnCompanies: Array<AxnCompany>): Array<FormattedRpServiceTemplate> => {
    const axnCompaniesMap = toObject<AxnCompany>(axnCompanies, 'id');
    return serviceTemplates.map(serviceTemplate => formatServiceTemplate(serviceTemplate, axnCompaniesMap));
};

export const formatServiceTemplate = (serviceTemplate: RpServiceTemplate, axnCompaniesMap: Record<string, AxnCompany>): FormattedRpServiceTemplate => {
    const { id, description, name, organizationID, status, relyingPartyID } = serviceTemplate;
    return {
        id, description, name, status,
        organization: axnCompaniesMap[organizationID],
        relyingPartyID
    };
};